module.exports = __webpack_public_path__ + "static/media/doodle-piggy-bank.fa4cbe68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/mobile/doodle-piggy-bank.svg
// module id = 1520
// module chunks = 49